module.exports = __webpack_public_path__ + "assets/img/btn-play-off.a003039d.png";